import type {
  PromotionPrerequisiteIssue,
  PromotionPrerequisitesError,
} from '../../services/BaseBackendService';

export function isPromotionPrerequisitesError(e: unknown): e is PromotionPrerequisitesError {
  return (
    typeof e === 'object' &&
    e !== null &&
    (e as PromotionPrerequisitesError).structuredError === true &&
    (e as PromotionPrerequisitesError).code === 'PROMOTION_PREREQUISITES'
  );
}

export function blockingPromotionIssues(
  issues: PromotionPrerequisiteIssue[],
): PromotionPrerequisiteIssue[] {
  return issues.filter((i) => !i.overridable);
}

export function overridableFundStatusIssues(
  issues: PromotionPrerequisiteIssue[],
): PromotionPrerequisiteIssue[] {
  return issues.filter((i) => i.overridable && i.issue === 'FUND_STATUS_REQUIRES_OVERRIDE');
}

/** Rejects from admin `BackendService` are plain objects shaped by `handleError`, not always `Error` instances. */
export function structuredApiErrorMessage(error: unknown): string {
  if (
    typeof error === 'object' &&
    error !== null &&
    'error' in error &&
    typeof (error as { error?: unknown }).error === 'string'
  ) {
    return (error as { error: string }).error;
  }
  if (error instanceof Error && error.message) {
    return error.message;
  }
  return typeof error === 'string' ? error : 'Something went wrong. Please try again.';
}
